module.exports = __webpack_public_path__ + "static/media/solar.2cbcb0e8.svg";